import { bodyCopyMedium, Col3Col9, DatePicker, DateUtil, ModalPopup, Switch } from '@aon/aon-tws-common-ui';
import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import * as React from 'react';
import _ from 'lodash';
import moment from 'moment';
import styled from 'styled-components';
import Constants from '../../constants';
import ContentConstants from '../../contentConstants';
import { IHasValidationModel } from '../../models';
import { IReportingProfileConfig } from '../../models/IReportingProfileConfig';
import { ValidationCollectionHelper } from '../../utilities';
import { SwitchWithLabelContainer } from '../audience/SharedComponents';
import { Timezone } from '../audience/Timezone';

const ModalContainer = styled.div`
	width: 100%;
	${bodyCopyMedium}
	font-weight: 600 !important;
	color: ${globalVars.gray1} !important;
`;

export interface IReportingProfileConfigEditModalProps extends IHasValidationModel {
	initialModel: IReportingProfileConfig;
	saving: boolean;
	onClosed: () => void;
	onUpdate: (model: IReportingProfileConfig, closeModal: boolean) => void;
}

interface IReportingProfileConfigEditModalState {
	openOn: string | null;
	isOpenImmediately: boolean;
}

export class ReportingProfileConfigEditModal extends React.Component<
	IReportingProfileConfigEditModalProps,
	IReportingProfileConfigEditModalState
> {
	public constructor(props: IReportingProfileConfigEditModalProps) {
		super(props);

		this.state = {
			isOpenImmediately: props.initialModel.isOpenImmediately,
			openOn: props.initialModel.openOn,
		};

		this.closeModal = this.closeModal.bind(this);
		this.saveModal = this.saveModal.bind(this);
		this.saveAndClose = this.saveAndClose.bind(this);
	}

	private get ModalConfiguration(): React.ComponentProps<typeof ModalPopup> {
		const saveDisabled = this.props.saving || _.isEqual(this.props.initialModel, this.getModelFromState());

		return {
			title: ContentConstants.REPORTING_PROFILES_TABLE_EDIT_MODAL_INVITE_TITLE,
			secondaryButtonText: ContentConstants.BUTTONS_CANCEL,
			primaryButtonText: ContentConstants.REPORTING_PROFILES_TABLE_EDIT_MODAL_SAVE_AND_CLOSE_BUTTON,
			alternatePrimaryButtonText: ContentConstants.REPORTING_PROFILES_TABLE_EDIT_MODAL_SAVE_BUTTON,

			isOpen: true,
			contentfullwidth: true,
			contenthcentered: false,
			contentoverflow: true,

			primaryButtonDisabled: saveDisabled,
			alternatePrimaryButtonDisabled: saveDisabled,

			onAlternatePrimaryButtonClick: this.saveModal,
			onSubmit: this.saveAndClose,
			onClosed: this.closeModal,
		};
	}

	public render() {
		const { isOpenImmediately } = this.state;
		const validationHelper = new ValidationCollectionHelper(this.props.validationResults);

		return (
			<ModalPopup {...this.ModalConfiguration}>
				<ModalContainer>
					<Col3Col9 label={ContentConstants.REPORTING_PROFILES_TABLE_EDIT_MODAL_GO_LIVE_DATE_LABEL}>
						<p>{ContentConstants.REPORTING_PROFILES_TABLE_EDIT_MODAL_GO_LIVE_DATE_DESCRIPTION}</p>
						<SwitchWithLabelContainer>
							<Switch checked={isOpenImmediately} onChange={() => this.setState({ isOpenImmediately: !isOpenImmediately, openOn: null })} />
							<div>{ContentConstants.REPORTING_PROFILES_TABLE_IMMEDIATELY_ON_SURVEY_CLOSE}</div>
						</SwitchWithLabelContainer>
						{!this.state.isOpenImmediately && (
							<DatePicker
								error={!validationHelper.IsValid('OpenOn')}
								message={validationHelper.Errors('OpenOn').toString()}
								className={'tws-reporting-profile-config-date-picker'}
								value={this.state.openOn}
								textInputPlaceholder={ContentConstants.REPORTING_PROFILES_TABLE_EDIT_MODAL_DATE_PICKER_PLACEHOLDER}
								clearText={ContentConstants.DATEPICKER_CLEARTEXT}
								enabledStartDate={moment()}
								defaultGap={0}
								onChange={(value) => this.setState({ openOn: DateUtil.getUtcDateTime(new Date(value)).toString() })}
								onClear={() => this.setState({ openOn: null })}
								dateFormat={Constants.DATE_FORMAT_LONG}
								headerLabel={ContentConstants.REPORTING_PROFILES_TABLE_EDIT_MODAL_GO_LIVE_DATE_LABEL}
							/>
						)}
					</Col3Col9>
					<Col3Col9 label={ContentConstants.REPORTING_PROFILES_TABLE_EDIT_MODAL_TIME_ZONE_LABEL}>
						<Timezone />
					</Col3Col9>
				</ModalContainer>
			</ModalPopup>
		);
	}

	private closeModal() {
		this.props.onClosed();
	}

	private getModelFromState() {
		const { initialModel } = this.props;
		const model: IReportingProfileConfig = {
			...initialModel,
			...this.state,
		};
		return model;
	}

	private async saveModal() {
		const model = this.getModelFromState();
		this.props.onUpdate(model, false);
	}

	private async saveAndClose() {
		const model = this.getModelFromState();
		this.props.onUpdate(model, true);
	}
}
